module.exports = __webpack_public_path__ + "static/media/profile-bg.58373371.jpg";